/**
 * @fileoverview An object representing a single row on a rendered block and all
 * of its subcomponents.
 */
"use strict";

import Blockly from "blockly";

// goog.provide('Blockly.gta.BottomRow');
// goog.provide('Blockly.gta.TopRow');
// goog.provide('Blockly.gta.AfterStatementSpacerRow');
// goog.provide('Blockly.gta.BeforeStatementSpacerRow');

// goog.require('Blockly.blockRendering.BottomRow');
// goog.require('Blockly.blockRendering.TopRow');
// goog.require('Blockly.blockRendering.SpacerRow');
// goog.require('Blockly.utils.object');

// 这里是第一个运行，需要创建 Blockly.gta
if (!Blockly.gta) {
  Blockly.gta = {};
}

/**
 * An object containing information about what elements are in the top row of a
 * block as well as sizing information for the top row.
 * Elements in a top row can consist of corners, hats, spacers, and previous
 * connections.
 * After this constructor is called, the row will contain all non-spacer
 * elements it needs.
 * @param {!Blockly.blockRendering.ConstantProvider} constants The rendering
 *   constants provider.
 * @package
 * @constructor
 * @extends {Blockly.blockRendering.TopRow}
 */
Blockly.gta.TopRow = function(constants) {
  Blockly.gta.TopRow.superClass_.constructor.call(this, constants);
};
Blockly.utils.object.inherits(
  Blockly.gta.TopRow,
  Blockly.blockRendering.TopRow
);

/**
 * @override
 */
Blockly.gta.TopRow.prototype.endsWithElemSpacer = function() {
  return false;
};

/**
 * Render a round corner unless the block has an output connection.
 * @override
 */
Blockly.gta.TopRow.prototype.hasLeftSquareCorner = function(block) {
  return !!block.outputConnection;
};

/**
 * Returns whether or not the top row has a right square corner.
 * @param {!Blockly.BlockSvg} block The block whose top row this represents.
 * @returns {boolean} Whether or not the top row has a left square corner.
 */
Blockly.gta.TopRow.prototype.hasRightSquareCorner = function(block) {
  // Render a round corner unless the block has an output connection.
  return !!block.outputConnection;
};

/**
 * An object containing information about what elements are in the bottom row of
 * a block as well as spacing information for the top row.
 * Elements in a bottom row can consist of corners, spacers and next
 * connections.
 * @param {!Blockly.blockRendering.ConstantProvider} constants The rendering
 *   constants provider.
 * @package
 * @constructor
 * @extends {Blockly.blockRendering.BottomRow}
 */
Blockly.gta.BottomRow = function(constants) {
  Blockly.gta.BottomRow.superClass_.constructor.call(this, constants);
};
Blockly.utils.object.inherits(
  Blockly.gta.BottomRow,
  Blockly.blockRendering.BottomRow
);

/**
 * @override
 */
Blockly.gta.BottomRow.prototype.endsWithElemSpacer = function() {
  return false;
};

/**
 * Render a round corner unless the block has an output connection.
 * @override
 */
Blockly.gta.BottomRow.prototype.hasLeftSquareCorner = function(block) {
  return !!block.outputConnection;
};

/**
 * Returns whether or not the bottom row has a right square corner.
 * @param {!Blockly.BlockSvg} block The block whose bottom row this represents.
 * @returns {boolean} Whether or not the bottom row has a left square corner.
 */
Blockly.gta.BottomRow.prototype.hasRightSquareCorner = function(block) {
  // Render a round corner unless the block has an output connection.
  return !!block.outputConnection;
};

/**
 * An object containing information about a row spacer that comes right
 *   before a statement input.
 * @param {!Blockly.blockRendering.ConstantProvider} constants The rendering
 *   constants provider.
 * @param {number} height The height of the spacer.
 * @param {number} width The width of the spacer.
 * @package
 * @constructor
 * @extends {Blockly.blockRendering.SpacerRow}
 */
Blockly.gta.BeforeStatementSpacerRow = function(constants, height, width) {
  Blockly.gta.BeforeStatementSpacerRow.superClass_.constructor.call(
    this,
    constants,
    height,
    width
  );
  this.type |= Blockly.blockRendering.Types.getType(
    "BEFORE_STATEMENT_SPACER_ROW"
  );
};
Blockly.utils.object.inherits(
  Blockly.gta.BeforeStatementSpacerRow,
  Blockly.blockRendering.SpacerRow
);

/**
 * An object containing information about a row spacer that comes right
 *   after a statement input.
 * @param {!Blockly.blockRendering.ConstantProvider} constants The rendering
 *   constants provider.
 * @param {number} height The height of the spacer.
 * @param {number} width The width of the spacer.
 * @package
 * @constructor
 * @extends {Blockly.blockRendering.SpacerRow}
 */
Blockly.gta.AfterStatementSpacerRow = function(constants, height, width) {
  Blockly.gta.AfterStatementSpacerRow.superClass_.constructor.call(
    this,
    constants,
    height,
    width
  );
  this.type |= Blockly.blockRendering.Types.getType(
    "AFTER_STATEMENT_SPACER_ROW"
  );
};
Blockly.utils.object.inherits(
  Blockly.gta.AfterStatementSpacerRow,
  Blockly.blockRendering.SpacerRow
);
